<template>
  <v-container width="100%" style="background: #f5f5f5">
    <div id="header" class="mt-3 px-3">
      <h2>Informações do equipamento</h2>
      <div>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              class="ma-1"
              color="#f5f5f5"
              dark
              @click="generatePDF(currentEquipment)"
              v-bind="attrs"
              v-on="on"
              small
            >
              <v-icon small color="#0F3565"> mdi-printer </v-icon>
            </v-btn>
          </template>
          <span>Imprimir</span>
        </v-tooltip>
      </div>
    </div>
    <v-divider class="my-3"></v-divider>

    <v-row
      class="px-5"
      v-if="currentEquipment.alienated"
      style="color: #df4759"
    >
      <v-col class="py-0" cols="12">
        <h3>Equipamento Alienado</h3>
      </v-col>
      <v-col class="pb-0" cols="12" sm="4" md="4" lg="4">
        <strong>Data:</strong>
        {{ formatDate(currentEquipment.alienationDate) }}
      </v-col>
      <v-col class="pb-0" cols="12" sm="8" md="8" lg="8">
        <strong>Motivo:</strong>
        {{ currentEquipment.alienationMotive }}
      </v-col>
    </v-row>
    <v-divider v-if="currentEquipment.alienated" class="my-3"></v-divider>
    <v-row class="px-5">
      <v-col class="py-0" cols="12" sm="6" md="6" lg="6">
        <p>
          <strong>MTBF Equipamento:</strong>
          {{ `${mtbf} dias` }}
        </p>
      </v-col>
      <v-col class="py-0" cols="12" sm="6" md="6" lg="6">
        <p>
          <strong>Data de cadastro:</strong>
          {{ formatDate(currentEquipment.create) }}
        </p>
      </v-col>
    </v-row>
    <v-divider></v-divider>
    <v-row class="px-5 py-0">
      <v-col cols="12">
        <h3>Dados gerais</h3>
      </v-col>
      <v-col class="py-0" cols="12" sm="4" md="4" lg="4">
        <p>
          <strong class="field">Identificação:</strong>
          {{ currentEquipment.identification }}
        </p>
      </v-col>
      <v-col class="py-0" cols="12" sm="4" md="4" lg="4">
        <p>
          <strong class="field">Instituição:</strong>
          {{ currentEquipment.institution.name }}
        </p>
      </v-col>
      <v-col class="py-0" cols="12" sm="4" md="4" lg="4">
        <p>
          <strong class="field">Unidade:</strong>
          {{ currentEquipment.unidade.name }}
        </p>
      </v-col>
      <v-col class="py-0" cols="12" sm="4" md="4" lg="4">
        <p>
          <strong class="field">Equip. Padrão:</strong>
          {{ currentEquipment.standardEquipment.name }}
        </p>
      </v-col>
      <v-col class="py-0" cols="12" sm="4" md="4" lg="4">
        <p>
          <strong class="field">Equipamento:</strong>
          {{
            currentEquipment.name != '' ? currentEquipment.name : 'Sem registro'
          }}
        </p>
      </v-col>
      <v-col class="py-0" cols="12" sm="4" md="4" lg="4">
        <p>
          <strong class="field">Setor:</strong>
          {{ currentEquipment.department.name }}
        </p>
      </v-col>

      <v-col class="py-0" cols="12" sm="4" md="4" lg="4">
        <p>
          <strong class="field">Cód Patrimônio:</strong>
          {{
            currentEquipment.propertyCode != ''
              ? currentEquipment.propertyCode
              : 'Sem registro'
          }}
        </p>
      </v-col>
      <v-col class="py-0" cols="12" sm="4" md="4" lg="4">
        <p>
          <strong class="field">{{ $t('Fabricante') }}:</strong>
          {{
            currentEquipment.manufacturer != ''
              ? currentEquipment.manufacturer
              : 'Sem registro'
          }}
        </p>
      </v-col>
      <v-col class="py-0" cols="12" sm="4" md="4" lg="4">
        <p>
          <strong class="field">Localização:</strong>
          {{
            currentEquipment.location != ''
              ? currentEquipment.location
              : 'Sem registro'
          }}
        </p>
      </v-col>
      <v-col class="py-0" cols="12" sm="4" md="4" lg="4">
        <p>
          <strong class="field">Modelo:</strong>
          {{
            currentEquipment.model != ''
              ? currentEquipment.model
              : 'Sem registro'
          }}
        </p>
      </v-col>
      <v-col class="py-0" cols="12" sm="4" md="4" lg="4">
        <p>
          <strong class="field">Nº Série:</strong>
          {{
            currentEquipment.serialNumber != ''
              ? currentEquipment.serialNumber
              : 'Sem registro'
          }}
        </p>
      </v-col>
      <v-col class="py-0" cols="12" sm="4" md="4" lg="4">
        <p>
          <strong class="field">Nº Anvisa:</strong>
          {{
            currentEquipment.numberAnvisa != ''
              ? currentEquipment.numberAnvisa
              : 'Sem registro'
          }}
        </p>
      </v-col>
      <v-col class="py-0" cols="12" sm="2" md="2" lg="2">
        <p class="mb-0">
          <strong class="field">{{ $t('Tensão') }}:</strong>
          {{
            currentEquipment.voltage != -1
              ? voltages[currentEquipment.voltage]
              : 'Sem registro'
          }}
        </p>
      </v-col>
      <v-col class="py-0" cols="12" sm="2" md="2" lg="2">
        <p class="mb-0">
          <strong class="field">Potência:</strong>
          {{
            currentEquipment.candlePower != ''
              ? `${currentEquipment.candlePower} W`
              : 'Sem registro'
          }}
        </p>
      </v-col>
      <v-col class="py-0" cols="12" sm="4" md="4" lg="4">
        <p class="mb-0">
          <strong class="field">Contrato:</strong>
          {{
            currentEquipment.contract != null
              ? currentEquipment.contract.name
              : 'Sem registro'
          }}
        </p>
      </v-col>
      <v-col class="py-0" cols="12" sm="3" md="3" lg="3">
        <p class="mb-0">
          <strong class="field">Valor contrato:</strong>
          {{
            currentEquipment.contractValue != 0
              ? `${currentEquipment.contractValue.toInstLocale()}`
              : 'Sem registro'
          }}
        </p>
      </v-col>
    </v-row>
    <v-divider class="my-3"></v-divider>

    <v-row class="px-5">
      <v-col class="pt-0" cols="12">
        <h3>Criticidade</h3>
      </v-col>
      <v-col class="py-0" cols="12" sm="4" md="4" lg="4">
        <p class="mb-0">
          <strong class="field">Função:</strong>
          {{
            functionsEquipment[
              currentEquipment.standardEquipment.functionEquipment
            ]
          }}
        </p>
      </v-col>
      <v-col class="py-0" cols="12" sm="4" md="4" lg="4">
        <p class="mb-0">
          <strong class="field">Risco:</strong>
          {{ equipmentRisks[currentEquipment.standardEquipment.equipmentRisk] }}
        </p>
      </v-col>
      <v-col class="py-0" cols="12" sm="1" md="1" lg="1">
        <p class="mb-0">
          <strong class="field">Grau:</strong>
          {{
            currentEquipment.degreeImportance != ''
              ? currentEquipment.degreeImportance
              : 'Sem registro'
          }}
        </p>
      </v-col>
      <v-col class="py-0" cols="12" sm="1" md="1" lg="1">
        <p class="mb-0">
          <strong class="field">Valor:</strong>
          {{
            currentEquipment.criticality != ''
              ? currentEquipment.criticality
              : 'Sem registro'
          }}
        </p>
      </v-col>
      <v-col class="py-0" cols="12" sm="2" md="2" lg="2">
        <p class="mb-0">
          <strong class="field">Criticidade:</strong>
          {{ getCriticalityLevel() }}
        </p>
      </v-col>
    </v-row>
    <v-divider class="my-3"></v-divider>

    <v-row class="px-5">
      <v-col class="pt-0" cols="12">
        <h3>Aquisição</h3>
      </v-col>
      <v-col class="py-0" cols="12" sm="4" md="4" lg="4">
        <p>
          <strong class="field">Fornecedor:</strong>
          {{
            currentEquipment.supplier != null
              ? currentEquipment.supplier.name
              : 'Sem registro'
          }}
        </p>
      </v-col>
      <v-col class="py-0" cols="12" sm="4" md="4" lg="4">
        <p>
          <strong class="field">Valor compra:</strong>
          {{
            currentEquipment.purchasePrice != 0
              ? `${currentEquipment.purchasePrice.toInstLocale()}`
              : 'Sem registro'
          }}
        </p>
      </v-col>
      <v-col class="py-0" cols="12" sm="4" md="4" lg="4">
        <p>
          <strong class="field">Câmbio do dia:</strong>
          {{
            currentEquipment.exchangeDay != 0
              ? `${currentEquipment.exchangeDay.toInstLocale()}`
              : 'Sem registro'
          }}
        </p>
      </v-col>
      <v-col class="py-0" cols="12" sm="4" md="4" lg="4">
        <p>
          <strong class="field">Situação:</strong>
          {{ situations[currentEquipment.equipmentAcquisitionSituation] }}
        </p>
      </v-col>
      <v-col class="py-0" cols="12" sm="4" md="4" lg="4">
        <p>
          <strong class="field">Data compra:</strong>
          {{
            currentEquipment.purchaseDate != null
              ? formatDate(currentEquipment.purchaseDate)
              : 'Sem registro'
          }}
        </p>
      </v-col>
      <v-col class="py-0" cols="12" sm="4" md="4" lg="4">
        <p>
          <strong class="field">Data entrega:</strong>
          {{
            currentEquipment.deliveryDate != null
              ? formatDate(currentEquipment.deliveryDate)
              : 'Sem registro'
          }}
        </p>
      </v-col>
      <v-col class="py-0" cols="12" sm="3" md="3" lg="3">
        <p class="mb-0">
          <strong class="field">Tempo garantia:</strong>
          {{
            currentEquipment.warrantyTime != null
              ? `${currentEquipment.warrantyTime} meses`
              : 'Sem registro'
          }}
        </p>
      </v-col>
      <v-col class="py-0" cols="12" sm="3" md="3" lg="3">
        <p class="mb-0">
          <strong class="field">Início garantia:</strong>
          {{
            currentEquipment.warrantyStartDate != null
              ? formatDate(currentEquipment.warrantyStartDate)
              : 'Sem registro'
          }}
        </p>
      </v-col>
      <v-col class="py-0" cols="12" sm="3" md="3" lg="3">
        <p class="mb-0">
          <strong class="field">Término garantia:</strong>
          {{
            currentEquipment.warrantyEndDate != null
              ? formatDate(currentEquipment.warrantyEndDate)
              : 'Sem registro'
          }}
        </p>
      </v-col>
      <v-col class="py-0" cols="12" sm="3" md="3" lg="3">
        <p class="mb-0">
          <strong class="field">Nota fiscal:</strong>
          {{
            currentEquipment.invoice != ''
              ? currentEquipment.invoice
              : 'Sem registro'
          }}
        </p>
      </v-col>
    </v-row>
    <v-divider class="my-3"></v-divider>

    <v-row class="px-5">
      <v-col class="pt-0" cols="12">
        <h3>Informações complementares</h3>
      </v-col>
      <v-col class="py-0" cols="12">
        <p>
          <strong class="field">Manuais que acompanham:</strong>
          {{
            currentEquipment.manuals != ''
              ? currentEquipment.manuals
              : 'Sem registro'
          }}
        </p>
      </v-col>
      <v-col class="py-0" cols="12">
        <p>
          <strong class="field">Acessórios e insumos:</strong>
          {{
            currentEquipment.accessories != ''
              ? currentEquipment.accessories
              : 'Sem registro'
          }}
        </p>
      </v-col>
      <v-col class="py-0" cols="12">
        <p>
          <strong class="field">Observações:</strong>
          {{
            currentEquipment.observation != ''
              ? currentEquipment.observation
              : 'Sem registro'
          }}
        </p>
      </v-col>
    </v-row>
  </v-container>
</template>

<style scoped>
#header {
  display: flex;
  justify-content: space-between;
}
.field {
  display: block;
}
</style>

<script>
import ApiService from '../../../../../../services/ApiService'
import Utils from '../../../../../../Utils/FormatDate'

export default {
  props: {
    receivedEquipment: {
      type: Object,
      required: true,
    },
  },

  created() {
    this.userType = JSON.parse(localStorage.getItem('institution')).userType

    this.currentEquipment = this.receivedEquipment
    this.getMtbf()
    document.getElementsByClassName('v-dialog--active')[0].scrollTop = 0
  },

  data: () => ({
    unidades: [],
    standardEquipment: [],
    currentStandardEquipment: {},
    departments: [],
    contracts: [],
    suppliers: [],
    unidadeName: '',
    departmentName: '',
    contractName: '',
    supplierName: '',
    mtbf: 0,
    userType: null,
    situations: [
      'Aluguel',
      'Comodato',
      'De médico/Equipe',
      'Empréstimo',
      'Próprio',
      'Terceiros',
    ],
    voltages: [
      '110V',
      '220V',
      '110V / 220V - Bivolt',
      '220V Trifásico',
      '380V Trifásico',
      '440V',
      '480V',
      '13,8KV',
    ],
    functionsEquipment: [
      'Acessório',
      'Análise',
      'Diagnóstico',
      'Outros equipamentos de apoio',
      'Suporte à vida',
      'Terapia',
    ],
    equipmentRisks: [
      'Acessório',
      'Injuria',
      'Morte',
      'Sem risco',
      'Terapia ou diagnóstico inapropriado',
    ],
    currentEquipment: {
      id: 0,
      standardEquipmentId: 0,
      departmentId: 0,
      contractId: 0,
      supplierId: 0,
      unidadeId: 0,
      name: '',
      propertyCode: '',
      manufacturer: '',
      location: '',
      model: '',
      serialNumber: '',
      voltage: null,
      candlePower: '',
      identification: '',
      contractValue: '',
      numberAnvisa: '',
      purchasePrice: '',
      purchaseDate: null,
      equipmentAcquisitionSituation: null,
      degreeImportance: null,
      exchangeDay: '',
      warrantyTime: '',
      deliveryDate: null,
      warrantyStartDate: null,
      warrantEndDate: null,
      installationEndDate: null,
      manuals: '',
      accessories: '',
      observation: '',
      alienated: false,
      criticality: 0,
      lifeExpectancy: 0,
      invoice: '',
    },
    apiService: new ApiService(),
  }),

  methods: {
    close() {
      this.$emit('close')
    },

    getCriticalityLevel() {
      if (
        this.currentEquipment.criticality >= 19 &&
        this.currentEquipment.criticality <= 27
      ) {
        return 'Alta'
      } else if (
        this.currentEquipment.criticality >= 12 &&
        this.currentEquipment.criticality <= 18
      ) {
        return 'Média'
      } else {
        return 'Baixa'
      }
    },

    async getMtbf() {
      await this.apiService
        .get(`equipment/mtbf/${this.currentEquipment.id}`)
        .then((response) => {
          this.mtbf = response.content
        })
    },

    async getUnidade() {
      const unidadeId = this.currentEquipment.unidadeId

      if (unidadeId != null) {
        await this.apiService.get(`unidade/${unidadeId}`).then((response) => {
          this.unidadeName = response.content.name
        })
      }
    },

    async getStandardEquipment() {
      const standardEquipmentId = this.currentEquipment.standardEquipmentId

      if (standardEquipmentId != null) {
        await this.apiService
          .get(`standardEquipment/${standardEquipmentId}`)
          .then((response) => {
            this.currentStandardEquipment = response.content
          })
      }
    },

    async getDepartment() {
      const departmentId = this.currentEquipment.departmentId

      if (departmentId != null) {
        await this.apiService
          .get(`department/${departmentId}`)
          .then((response) => {
            this.departmentName = response.content.name
          })
      }
    },

    async getContract() {
      const contractId = this.currentEquipment.contractId

      if (contractId != null) {
        await this.apiService.get(`contract/${contractId}`).then((response) => {
          this.contractName = response.content.name
        })
      }
    },

    async getSupplier() {
      const supplierId = this.currentEquipment.supplierId

      if (supplierId != null) {
        await this.apiService.get(`supplier/${supplierId}`).then((response) => {
          this.supplierName = response.content.name
        })
      }
    },

    async generatePDF(equipment) {
      this.apiService
        .get(`equipment/printEquipment/${equipment.id}`)
        .then((response) => {
          response = 'data:application/pdf;base64,' + response.content
          const link = document.createElement('a')
          link.href = response
          link.setAttribute(
            'download',
            `Equipamento:${equipment.id}_${this.formatDate(new Date())}`
          )
          document.body.appendChild(link)
          link.click()
        })
        .catch(() => {})

      this.$emit('show', 'Baixando PDF!')
    },

    formatDate(date) {
      return Utils.moment(date)
    },
  },
}
</script>

<style></style>
